export default import.meta.ROLLUP_FILE_URL_D6DpfIy6e1L3BSRaGRC2qw